import React from 'react';
import { BaseIcon } from '../../base/BaseIcon';
import { IconProps } from '../../types';

export const TsplatShowPointsIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M12.51 10.88H11.5C11.1576 10.88 10.88 11.1576 10.88 11.5V12.51C10.88 12.8524 11.1576 13.13 11.5 13.13H12.51C12.8524 13.13 13.13 12.8524 13.13 12.51V11.5C13.13 11.1576 12.8524 10.88 12.51 10.88Z"
        fill={color}
      />
      <path
        d="M3.30999 20.07H2.29999C1.95758 20.07 1.67999 20.3476 1.67999 20.69V21.7C1.67999 22.0424 1.95758 22.32 2.29999 22.32H3.30999C3.65241 22.32 3.92999 22.0424 3.92999 21.7V20.69C3.92999 20.3476 3.65241 20.07 3.30999 20.07Z"
        fill={color}
      />
      <path
        d="M11.09 19.36H10.08C9.73759 19.36 9.46001 19.6376 9.46001 19.98V20.99C9.46001 21.3324 9.73759 21.61 10.08 21.61H11.09C11.4324 21.61 11.71 21.3324 11.71 20.99V19.98C11.71 19.6376 11.4324 19.36 11.09 19.36Z"
        fill={color}
      />
      <path
        d="M4.02 12.29H3.01C2.66758 12.29 2.39 12.5676 2.39 12.91V13.92C2.39 14.2624 2.66758 14.54 3.01 14.54H4.02C4.36242 14.54 4.64 14.2624 4.64 13.92V12.91C4.64 12.5676 4.36242 12.29 4.02 12.29Z"
        fill={color}
      />
      <path
        d="M7.63999 6.01001H6.62999C6.28758 6.01001 6.00999 6.28759 6.00999 6.63001V7.64001C6.00999 7.98243 6.28758 8.26001 6.62999 8.26001H7.63999C7.98241 8.26001 8.25999 7.98243 8.25999 7.64001V6.63001C8.25999 6.28759 7.98241 6.01001 7.63999 6.01001Z"
        fill={color}
      />
      <path
        d="M17.37 15.74H16.36C16.0176 15.74 15.74 16.0176 15.74 16.36V17.37C15.74 17.7124 16.0176 17.99 16.36 17.99H17.37C17.7124 17.99 17.99 17.7124 17.99 17.37V16.36C17.99 16.0176 17.7124 15.74 17.37 15.74Z"
        fill={color}
      />
      <path
        d="M20.99 9.45999H19.98C19.6376 9.45999 19.36 9.73757 19.36 10.08V11.09C19.36 11.4324 19.6376 11.71 19.98 11.71H20.99C21.3324 11.71 21.61 11.4324 21.61 11.09V10.08C21.61 9.73757 21.3324 9.45999 20.99 9.45999Z"
        fill={color}
      />
      <path
        d="M13.92 2.39001H12.91C12.5676 2.39001 12.29 2.6676 12.29 3.01001V4.02001C12.29 4.36243 12.5676 4.64001 12.91 4.64001H13.92C14.2624 4.64001 14.54 4.36243 14.54 4.02001V3.01001C14.54 2.6676 14.2624 2.39001 13.92 2.39001Z"
        fill={color}
      />
      <path
        d="M21.7 1.67999H20.69C20.3476 1.67999 20.07 1.95758 20.07 2.29999V3.30999C20.07 3.65241 20.3476 3.92999 20.69 3.92999H21.7C22.0424 3.92999 22.32 3.65241 22.32 3.30999V2.29999C22.32 1.95758 22.0424 1.67999 21.7 1.67999Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

TsplatShowPointsIcon.displayName = 'TsplatShowPointsIcon';
